module.exports = __webpack_public_path__ + "assets/img/246801.5ca39127.png";